import { inject, injectable } from 'tsyringe';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { type IAgentEditRepository } from 'application/repositorySchemas/IAgentEditRepository';
import { type IAgentEditClient } from 'interfaceAdapter/gatewaySchemas/IAgentEditClient';

@injectable()
export class AgentEditRepository implements IAgentEditRepository {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAgentEditClient')
        public readonly agentEditClient: IAgentEditClient,
    ) {}

    // TODO 型づけをサボっている
    public async edit(agent: any) {
        const { data, message } = await this.agentEditClient.post({
            token: this.agentUserToken.get() || '',
            agent,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
